// ABOUTME: Route file for /teams-link (public, no auth required).
// ABOUTME: Renders the TeamsLinkPage for linking Teams users to Tendrel accounts.

import TeamsLinkPage from "@/pages/TeamsLinkPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/teams-link")({
  component: TeamsLinkPage,
});
